import { useTimeSince } from 'client/hooks/useTimeSince';

interface TimeProps {
  dateTime: string;
  prefix?: string;
}

export const Time = ({ dateTime, prefix, ...other }: TimeProps) => {
  const date = new Date(dateTime);
  const timeSince = useTimeSince(dateTime, { addSuffix: true });

  return (
    <time dateTime={date.toISOString()} title={date.toLocaleString()} {...other}>
      {prefix}
      {timeSince}
    </time>
  );
};
